import type { ReactNode } from 'react';
import cn from 'classnames';
import s from './BaseList.scss';

interface Props<ResultType> {
  results: ResultType[];
  renderItem: (result: ResultType, idx: number) => ReactNode;
  beforeItems?: ReactNode;
  afterItems?: ReactNode;
  className?: string;
  itemClassName?: string;
}

function BaseList<ResultType>({
  results,
  renderItem,
  beforeItems,
  afterItems,
  className,
}: Props<ResultType>) {
  return (
    <div className={cn(s['list'], className)}>
      {beforeItems}
      {results.map((result, idx) => renderItem(result, idx))}
      {afterItems}
    </div>
  );
}
BaseList.displayName = 'BaseList';

export default BaseList;
